export default __webpack_public_path__ + "static/media/people3.8864f0da.jpg";